import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import { JOURNAL_ENTRY_FIELDS } from "./source-fields";

export const journalEntrySources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.ACCOUNTING_JOURNAL_ENTRIES_CREATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.MANUAL_JOURNAL_ENTRY,
                fields: JOURNAL_ENTRY_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.SOURCE_COUNT_DISTINCT,
        platformTwins: [APIProcessName.PLATFORM_CREATE_JOURNAL_ENTRY],
        enabled: true,
    },
    {
        sourceType: APIProcessName.ACCOUNTING_JOURNAL_ENTRIES_BULK_CREATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.MANUAL_JOURNAL_ENTRY,
                fields: JOURNAL_ENTRY_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.SOURCE_COUNT_DISTINCT,
        platformTwins: [APIProcessName.PLATFORM_BULK_CREATE_JOURNAL_ENTRIES],
        enabled: true,
    },
    {
        sourceType: APIProcessName.ACCOUNTING_JOURNAL_ENTRIES_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.MANUAL_JOURNAL_ENTRY,
                fields: JOURNAL_ENTRY_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.SOURCE_COUNT_DISTINCT,
        platformTwins: [APIProcessName.PLATFORM_UPDATE_JOURNAL_ENTRY],
        enabled: true,
    },
    {
        sourceType: APIProcessName.ACCOUNTING_JOURNAL_ENTRIES_DELETE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.MANUAL_JOURNAL_ENTRY,
                fields: JOURNAL_ENTRY_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.SOURCE_COUNT_DISTINCT,
        platformTwins: [APIProcessName.PLATFORM_DELETE_JOURNAL_ENTRY],
        enabled: true,
    },
];
